export default {
	themes: {
		light: 'Clair',
		dark: 'Sombre'
	}
};
